import React, {useContext} from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import StorageIcon from '@mui/icons-material/Storage';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import ApiIcon from '@mui/icons-material/Api';
import DvrIcon from '@mui/icons-material/Dvr';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import EmailIcon from '@mui/icons-material/Email';
import GroupIcon from '@mui/icons-material/Group';
import { ActiveSectionContext } from '../view-it-dashboard2';

const mainListItems = [
    { text: 'Dashboard', value: 'dashboard', icon: <HomeRoundedIcon /> },
    { text: 'Reporter 7', value: 'r7', icon: <DvrIcon /> },
    { text: 'OCPF.US', value: 'website', icon: <AnalyticsRoundedIcon /> },
    { text: 'Search Engine', value: 'searches', icon: <ManageSearchIcon /> },
    { text: 'Databases', value: 'databases', icon: <StorageIcon /> },
    { text: 'Azure Cloud', value: 'azure', icon: <CloudQueueIcon /> },
    { text: 'API Servers', value: 'apis', icon: <ApiIcon /> },
    { text: 'Email Server', value: 'emails', icon: <EmailIcon /> },
    { text: 'Data Backup', value: 'backup', icon: <CloudSyncIcon /> },
    { text: 'Tickets', value: 'tickets', icon: <AssignmentRoundedIcon /> },
    { text: 'Staff Roles', value: 'staff', icon: <GroupIcon /> },
];

const MenuContent = (): JSX.Element => {

    const context = useContext(ActiveSectionContext);

    const switchActiveSection = (section: string) => {
        context.setActiveSection(section);
    }

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
            <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                <ListItemButton onClick={() => switchActiveSection(item.value)} selected={index === 2}>
                    <ListItemIcon sx={{ minWidth: "48px" }} >{item.icon}</ListItemIcon>
                    <ListItemText
                        primary={item.text}
                    />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}

export default MenuContent;